var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-outlined is-fullwidth",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',{staticStyle:{"text-align":"left","display":"inline-block","width":"180px","max-width":"100%","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._t("default")],2),_c('b-icon',{attrs:{"icon":"caret-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }